import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

const MyPreset = definePreset(Lara, {
    semantic: {
        form: {
            field: {
                padding: {
                    x: '1rem',
                    y: '0.75rem',
                },
            },
            checkbox: {
                iconCheckedColor: 'white',
            },
        },
        formField: {
            paddingY: '0.75rem',
        },
        disabled: {
            opacity: '0.4',
        },
        primary: {
            50: '#e7dfff',
            100: '#dbcdfe',
            200: '#c4a8fb',
            300: '#ac84f9',
            400: '#7D3BF4',
            500: '#7D3BF4',
            600: '#6e2ed3',
            700: '#6021b3',
            800: '#511492',
            900: '#420771',
            950: '#3b0061',
        },
        colorScheme: {
            light: {
                surface: {
                    0: '#FCFCFC',
                    50: '#F9F9F9',
                    100: '#eff2f5',
                    200: '#D1D3E3',
                    300: '#b1adb9',
                    400: '#92939D', // (unchanged)
                    500: '#686870',
                    600: '#3E3E42',
                    700: '#35353A', // (unchanged)
                    800: '#2A2B30', // (unchanged)
                    900: '#1E1E1F',
                    950: '#0d0a12',
                },
                highlight: {
                    // background: 'rgba(250, 250, 250, .16)',
                    // focusBackground: 'rgba(250, 250, 250, .24)',
                    // color: 'rgba(255,255,255,.87)',
                    // focusColor: 'rgba(255,255,255,.87)',
                },
                content: {
                    background: '{surface.100}',
                    // hoverBackground: '{surface.100}',
                    // color: '{surface.800}',
                    // hoverColor: '#ff00ff',
                },
                formField: {
                    background: '{surface.0}',
                    hoverBorderColor: '{primary.color}',
                    borderColor: '{surface.200}',
                    // focusBackground: '{surface.800}',
                    focusBorderColor: '{primary.color}',
                    placeholderColor: '{surface.500}',
                },
                text: {
                    muted: {
                        color: '{surface.500}',
                    },
                },
            },
            dark: {
                surface: {
                    0: '#FCFCFC',
                    50: '#F9F9F9',
                    100: '#EAEBF5',
                    200: '#D1D3E3',
                    300: '#b1adb9',
                    400: '#92939D', // (unchanged)
                    500: '#686870',
                    600: '#3E3E42',
                    700: '#35353A', // (unchanged)
                    800: '#2A2B30', // (unchanged)
                    900: '#1E1E1F',
                    950: '#0d0a12',
                },
                primary: {
                    // color: '#ff0000',
                    contrastColor: '#ffffff',
                },
                highlight: {
                    background: 'rgba(250, 250, 250, .16)',
                    focusBackground: 'rgba(250, 250, 250, .24)',
                    color: 'rgba(255,255,255,.87)',
                    focusColor: 'rgba(255,255,255,.87)',
                },
                content: {
                    background: '{surface.900}',
                    hoverBackground: '{surface.800}',
                    color: '{surface.200}',
                    // hoverColor: '#ff00ff',
                },
                formField: {
                    background: '{surface.800}',
                    hoverBorderColor: '{primary.color}',
                    borderColor: '{surface.700}',
                    focusBackground: '{surface.800}',
                    focusBorderColor: '{primary.color}',
                    placeholderColor: '{surface.500}',
                    floatLabelColor: '{surface.300}',
                },
                text: {
                    muted: {
                        color: '{surface.400}',
                    },
                },
            },
        },
    },
    components: {
        button: {
            // sm: {
            //     font: {
            //         size: '90%',
            //     },
            // },
            extend: {
                lighter: {
                    backgroundColor: '{surface.700} !important',
                    borderColor: '{surface.600} !important',
                },
                tiny: {
                    font: {
                        size: '12px',
                        weight: 'bold',
                    },
                    padding: '0.25rem 1rem',
                },
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-button-xs .p-button-label {
                    font-size: 80%;
                }
                .p-button-lighter {
                    border-color: ${dt('button.lighter.border.color')};
                    background-color: ${dt('button.lighter.background.color')};
                }
                .p-button.p-button-tiny {
                    font-size: ${dt('button.tiny.font.size')};
                    font-weight: ${dt('button.tiny.font.weight')};
                    padding: ${dt('button.tiny.padding')};
                }
                .p-button-text.p-button-tiny {
                    color:var(--p-surface-500);
                    font-size: 13px;
                    padding: 0.25rem;
                    width: inherit;
                }
                .p-button-text.p-button-tiny.lighter {
                    color:var(--p-surface-200);
                }
            `,
            root: {
                paddingX: '1.5rem',
                paddingY: '0.75rem',
                sm: {
                    paddingY: '0.5rem',
                },
            },
            colorScheme: {
                dark: {
                    root: {
                        primary: {
                            color: '{surface.200} !important',
                            hoverBackground: '{primary.300} !important',
                        },
                        secondary: {
                            borderColor: '{surface.600} !important',
                            hoverBorderColor: '{primary.color} !important',
                        },
                    },
                    text: {
                        primary: {
                            color: '{surface.200} !important',
                            hoverBackground: '{primary.300} !important',
                        },
                    },
                },
                light: {
                    root: {
                        secondary: {
                            borderColor: '{surface.200} !important',
                            hoverBorderColor: '{primary.color} !important',
                        },
                    },
                },
            },
        },
        togglebutton: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-selectbutton {
                  padding: 4px 6px;
                  border-radius: 10px;
                  background: var(--p-surface-100);
                }
                .theme-dark .p-selectbutton {
                  background: var(--p-surface-800);
                }
                .p-selectbutton .p-togglebutton {
                  padding: 4px 9px;
                  border-radius: 6px !important;
                  border: none;
                }
                .p-selectbutton .p-togglebutton:first-child {
                  border-radius: 8px;
                }
                .p-togglebutton-sm .p-togglebutton-content {
                  padding: 1px;
                }
                `,
            root: {
                checkedBackground: '{primary.color}',
                checkedColor: '{surface.0} !important',
                padding: '0.875rem 2rem',
                fontWeight: '600',
            },
            colorScheme: {
                // padding: {
                //     x: '2rem',
                //     y: '0.875rem',
                // },
                dark: {
                    root: {
                        color: '{surface.400} !important',
                    },
                },
            },
        },
        card: {
            body: {
                padding: '1rem',
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
              .p-card {
                border: 1px solid var(--p-surface-200);
              }
              .theme-dark {
                .p-card {
                  border: 1px solid var(--p-surface-700);
                }
            }
            `,
            colorScheme: {
                dark: {
                    root: {
                        background: '{surface.800}',
                    },
                },
                light: {
                    root: {
                        background: '{surface.0}',
                    },
                },
            },
        },
        icon: {
            size: '1.5rem',
        },
        inputicon: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-inputicon {
                    z-index: 1;
                }`,
        },
        autocomplete: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-iconfield .p-autocomplete-input {
                  padding-left: 44px;
                }`,
            option: {
                selectedColor: '{primary.color}',
                selectedBackground: 'rgba(159, 100, 209, .12)',
                selectedFocusColor: '{primary.color}',
                selectedFocusBackground: 'rgba(159, 100, 209, .12)',
            },
        },
        inputtext: {
            root: {
                paddingY: '0.75rem',
            },
            colorScheme: {
                dark: {
                    root: {
                        disabledBackground: '{surface.800}',
                    },
                },
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                p-columnfilterformelement .p-inputtext {
                    padding: 0.35rem 1rem;
                    font-size: small;
                    width: 100%;
                },
                .p-inputtext:disabled {
                    opacity: 0.4 !important;
                }`,
        },
        select: {
            // padding: {
            //     y: '0.725rem',
            //     // x: '0.75rem',
            // },
            optionGroup: {
                padding: '0.25rem 0.625rem',
            },
            root: {
                sm: {
                    paddingY: '0.5rem',
                },
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                small .p-select span.p-select-label, .p-select.small span.p-select-label, small .p-dropdown .p-multiselect-label, small .p-multiselect .p-inputtext, small .p-multiselect .p-multiselect-label {
                    padding: 0.35rem 0.25rem 0.35rem 0.75rem;
                    font-size: small;
                }
                .p-select-label {
                    line-height: 1.2;
                }
                p-columnfilterformelement .p-select-label, .p-paginator-rpp-dropdown .p-select-label {
                    padding: 0.35rem 1rem;
                    font-size: small;
                }
                .p-disabled {
                    opacity: 0.4 !important;
                }
                .no-arrow {
                    padding-right: 0;
                }
                .no-arrow .p-select-dropdown {
                    display: none;
                }`,
            colorScheme: {
                dark: {
                    root: {
                        disabledBackground: '{surface.800}',
                        filledHoverBackground: '{surface.800}',
                    },
                    option: {
                        selectedColor: '{primary.color}',
                        selectedBackground: 'rgba(159, 100, 209, .12)',
                        selectedFocusColor: '{primary.color}',
                        selectedFocusBackground: 'rgba(159, 100, 209, .12)',
                    },
                    optionGroup: {
                        background: '{surface.800}',
                    },
                },
            },
        },
        multiselect: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                p-columnfilterformelement .p-multiselect-label {
                    padding: 0.35rem 1rem;
                    font-size: small;
                }
                .p-iftalabel .p-multiselect-label {
                    padding-block-start: 1.5rem;
                    padding-block-end: 0.2875rem;
                }`,
        },
        panel: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-panel.lighter {
                    background: var(--p-panel-header-background);
                }`,
            header: {
                padding: '1rem',
            },
            content: {
                padding: '1rem',
            },
        },
        skeleton: {
            colorScheme: {
                dark: {
                    root: {
                        background: 'rgba(155,161,192,0.06)  !important',
                    },
                },
            },
        },
        accordion: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-accordionpanel {
                    border: none;
                    border-bottom: 1px solid var(--p-content-border-color);
                }
                .p-accordionheader {
                    border: none;
                }
                .overview-panel .p-accordion-header {
                    padding-top: 0;
                }
                .overview-panel .p-accordionheader-toggle-icon {
                    display: none;
                }
                .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader i {
                    color: var(--p-primary-color);
                }
                .p-accordionpanel:not(.p-disabled).p-accordionpanel-active > .p-accordionheader svg {
                    color: var(--p-primary-color);
                }
                .p-accordionpanel:not(.p-accordionpanel-active) > .p-accordioncontent {
                    height: 0;
                }
            `,
            header: {
                padding: '0.75rem 0',
            },
            content: {
                padding: '0 0 1.125rem 0',
                borderWidth: '0',
            },
            colorScheme: {
                dark: {
                    header: {
                        background: '{surface.900} !important',
                        hoverBackground: '{surface.900} !important',
                        activeBackground: '{surface.900} !important',
                        activeHoverBackground: '{surface.900} !important',
                    },
                    content: {
                        background: '{surface.900}',
                    },
                },
                light: {
                    header: {
                        background: '{surface.100} !important',
                        hoverBackground: '{surface.100} !important',
                        activeBackground: '{surface.100} !important',
                        activeHoverBackground: '{surface.100} !important',
                    },
                    content: {
                        background: '{surface.100}',
                    },
                },
            },
        },
        datatable: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                p-table .p-datatable-tbody > tr > td, .p-multiselect .p-datatable-tbody > tr > td {
                    font-size: small;
                }
                .p-datatable-table {
                    border: 1px solid var(--p-datatable-header-cell-border-color);
                }
                .p-datatable-thead > tr:nth-child(2) > th {
                    background: var(--p-datatable-row-background);
                }`,
            colorScheme: {
                dark: {
                    root: {
                        borderColor: '{surface.700}',
                    },
                    headerCell: {
                        color: '{surface.200}',
                        background: '{surface.800}',
                        padding: '0.5rem 1rem',
                    },
                    row: {
                        selectedColor: '{primary.color}',
                        selectedBackground: 'rgba(159, 100, 209, .12)',
                    },
                },
            },
        },
        tabs: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
              .p-tab {
              background: transparent;
              }`,
            tab: {
                background: 'transparent',
                borderWidth: '0 0 1px 0 !important',
                activeColor: '{surface.800}',
            },
            tablist: {
                borderWidth: '0 0 1px 0 !important',
            },
            colorScheme: {
                dark: {
                    tab: {
                        activeColor: '{surface.0}',
                    },
                },
            },
        },
        datepicker: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-datepicker-input {
                  width: 100%;
              }`,
            dropdown: {
                hoverBorderColor: '{primary.color}',
            },
            colorScheme: {
                light: {
                    dropdown: {
                        background: '{surface.200}',
                    },
                },
            },
        },
        chip: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-chip {
                    background: var(--p-primary-color);
                    color: #ffffff;
                }
                .p-chip-remove-icon {
                    color: #ffffff;
                }`,
            root: {
                paddingY: '0.5rem',
            },
        },
        tag: {
            root: {
                padding: '0.25rem 1rem',
                roundedBorderRadius: '6px',
            },
            extend: {
                'severity-Low': {
                    background: '#a29aa9',
                },
                'severity-Medium': {
                    background: '#faca00',
                },
                'severity-High': {
                    background: '#FF9900',
                },
                'severity-Severe': {
                    background: '#FF666C',
                },
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .severity-Low.p-tag-info {
                    background: ${dt('tag.severity-Low.background')};
                }
                .severity-Medium.p-tag-info {
                    background: ${dt('tag.severity-Medium.background')};
                }
                .severity-High.p-tag-info {
                    background: ${dt('tag.severity-High.background')};
                }
                .severity-Severe.p-tag-info {
                    background: ${dt('tag.severity-Severe.background')};
                }
            `,
        },
        toolbar: {
            root: {
                padding: '0.5rem',
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
              .theme-dark {
                .p-toolbar {
                  background: var(--p-surface-900);
                  border-color: var(--p-surface-700);
                }
              }`,
        },
        tree: {
            extend: {
                noIcon: {
                    color: '{surface.200}',
                },
            },
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .no-icon .p-tree-node-toggle-button {
                    display: none;
                }
                .p-tree-node-leaf > .p-tree-node-content .p-tree-node-toggle-button {
                    display: none;
                }
                    `,
            root: {
                gap: '0.5rem',
            },
            node: {
                gap: '0.5rem',
                padding: '0.5rem 0.625rem',
            },
            nodeIcon: {
                selectedColor: '{primary.color}',
            },
            nodeToggleButton: {
                size: '1.5rem',
            },
            colorScheme: {
                dark: {
                    root: {
                        background: '{surface.900}',
                    },
                    node: {
                        color: '{surface.400}',
                        // content: {
                        //     color: '{surface.500}',
                        // },
                        selectedBackground: '{surface.700}',
                        selectedColor: '#ffffff',
                    },
                },
                light: {
                    root: {
                        background: '{surface.100}',
                    },
                },
            },
        },
        slider: {
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
            .p-slider.p-slider-horizontal {
                margin-left: 7px;
                margin-right: 7px;
            }`,
            track: {
                size: '2px',
                background: '{surface.400}',
            },
            handle: {
                height: '14px',
                width: '14px',
                content: {
                    height: '8px',
                    width: '8px',
                },
            },
        },
        iftalabel: {
            input: {
                paddingTop: '1.65rem',
                paddingBottom: '0.5rem',
            },
        },
        dialog: {
            extend: {
                modern: {
                    backgroundColor: '{surface.700} !important',
                    borderColor: '{surface.600} !important',
                },
            },
            // css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
            //     .p-button-xs .p-button-label {
            //         font-size: 80%;
            //     }
            //     .p-button-lighter {
            //         border-color: ${dt('button.lighter.border.color')};
            //         background-color: ${dt('button.lighter.background.color')};
            //     }
            //     .p-button.p-button-tiny {
            //         font-size: ${dt('button.tiny.font.size')};
            //         font-weight: ${dt('button.tiny.font.weight')};
            //         padding: ${dt('button.tiny.padding')};
            //     }
            //     .p-button-text.p-button-tiny {
            //         color:var(--p-surface-500);
            //         font-size: 13px;
            //         padding: 0.25rem;
            //         width: inherit;
            //     }
            // `,
            css: ({ dt }: { dt: (key: string) => string | number | undefined }) => `
                .p-dialog.modern {
                  max-width: 720px;
                }
                .p-dialog.modern .p-dialog-header {
                  padding: 0.5rem 1rem;
                  background: var(--p-surface-800);
                  border-radius: 8px 8px 0 0;
              }
                .p-dialog.modern .p-dialog-title {
                font-size: 1rem;
              }
                .p-dialog.modern .p-dialog-header-actions .p-button-text {
                  padding: 0.25rem;
                  width: 1.5rem;
                  height: 1.5rem;

              }
              .p-dialog-title {
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
              }
              .p-dialog-footer {
                  padding: 1rem 1.5rem;
              }
              .p-dialog-content {
                padding-top: 1rem;}
            `,
            content: {
                padding: '1rem 1.5rem',
            },
            header: {
                padding: '1rem 1.5rem',
            },
            title: {
                fontSize: '1.5rem',
            },
            colorScheme: {
                dark: { root: { shadow: '0 2px 6px 1px #000' } },
            },
        },
        overlay: {
            modalPadding: '1rem',
        },
    },
});

export default MyPreset;
